import { Component, HostListener } from "@angular/core";

@Component({
  template: ''
})

export class DesignHelper {

  scale = 1;

  onDragEnded(event: any) {
    let element = event.source.getRootElement();
    let boundingClientRect = element.getBoundingClientRect();
    let parentPosition = this.getPosition(element);

    let x = parseInt(boundingClientRect.x) - Number(parentPosition.left)
    let y = parseInt(boundingClientRect.y) - Number(parentPosition.top)

    console.log('Position:', x, y);

    let zoomMoveXDifference = 0;
    let zoomMoveYDifference = 0;
    if (this.scale) {
     zoomMoveXDifference = (1 - this.scale) * x;
     zoomMoveYDifference = (1 - this.scale) * y;
     x = x + zoomMoveXDifference
     y = y + zoomMoveYDifference
     console.log('Position:', x, y);
    }

    return { x: Number(x.toFixed()), y: Number(y.toFixed()) }
  }
  getPosition(el: any) {
    let x = 0;
    let y = 0;
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
      x += el.offsetLeft - el.scrollLeft;
      y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }

    return { top: y, left: x };
  }

  dragConstrainPoint = (point: any, dragRef: any) => {
    let zoomMoveXDifference = 0;
    let zoomMoveYDifference = 0;
    if (this.scale! - 1) {
      zoomMoveXDifference = (1 - this.scale) * dragRef.getFreeDragPosition().x;
      zoomMoveYDifference = (1 - this.scale) * dragRef.getFreeDragPosition().y;
    }
    return {
      x: point.x + zoomMoveXDifference,
      y: point.y + zoomMoveYDifference
    };
  }

  @HostListener('window:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Backspace' || event.key === 'Delete') {

    }
  }
}
